import React from 'react';
import { FaMapMarkerAlt, FaShieldAlt, FaWallet } from 'react-icons/fa';

const FeatureItem = ({ icon, title, text }) => (
  // Updated: The individual boxes now have a black border
  <div className="bg-slate-800 rounded-lg p-6">
    <div className="flex flex-col items-center text-center">
      <div className="text-amber-400 text-4xl mb-4">{icon}</div>
      <h3 className="font-bold text-lg mb-2 text-white">{title}</h3>
      <p className="text-slate-400 text-sm max-w-xs">{text}</p>
    </div>
  </div>
);

const Features = () => {
  return (
    // Updated: The main container div now spans the full width of the section
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-slate-950">
      <div className="bg-slate-800 rounded-3xl py-16 px-8 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureItem 
            icon={<FaMapMarkerAlt />} 
            title="Best price" 
            text="We offer the best prices for car rentals in the market." 
          />
          <FeatureItem 
            icon={<FaShieldAlt />} 
            title="Certified" 
            text="All our vehicles are certified and regularly maintained." 
          />
          <FeatureItem 
            icon={<FaWallet />} 
            title="Fast booking" 
            text="You can book your car in just a few simple steps." 
          />
        </div>
      </div>
    </section>
  );
}

export default Features;